import { addQueries } from '../../api/makeRequest'
import { GOOGLE_MAPS_URL } from '../../constants/urls'

export const getGoogleMapsUrl = (lat: number, lng: number) => {
  const query = `${lat}${encodeURI(',')}${lng}`

  const googleMapsUrl = `${addQueries(GOOGLE_MAPS_URL, {
    query,
  })}`

  return googleMapsUrl
}
